module.exports = __webpack_public_path__ + "img/icon-cart-active.ee8a6473.svg";